export default __webpack_public_path__ + "static/ppc-review-2-f599bef47247e42cc94bd0a8b15cc94c.png";